import { SET_STORAGE, USER, GET_STORAGE, REMOVE_STORAGE, AJAX_PUBLIC_REQUEST, SET_LOGIN_COOKIE, DELETE_LOGIN_COOKIE, DELETE_COOKIE } from '../../Constants/AppConstants';
import history from '../../history';

import { SET_CURRENT_USER, SET_MUTE, SET_AUTOASSIGN, SET_FULLSTORY, SET_LEAD_PROCESS_STATUS, SET_RELOAD_REPLY, SET_LIVE_LEAD_COUNT } from './actionTypes';

export function setCurrentUser(user) {
    return {
        type: SET_CURRENT_USER,
        user
    }
}

export function logout() {
    return dispatch => {
        REMOVE_STORAGE(USER);
        DELETE_COOKIE(USER);
        DELETE_LOGIN_COOKIE();
        REMOVE_STORAGE('autoAssignInfo');
        REMOVE_STORAGE('activityTimeLeft');
        REMOVE_STORAGE('idleTimeLeft');
        REMOVE_STORAGE('user_id');
        REMOVE_STORAGE('contact_id');
        REMOVE_STORAGE('getlocaltime');
        dispatch(setCurrentUser({}));
        history.push('/login?t=' + new Date().getTime());
    }
}

export function serviceLogout() {
    return dispatch => {
        REMOVE_STORAGE(USER);
        DELETE_COOKIE(USER);
        DELETE_LOGIN_COOKIE();
        dispatch(setCurrentUser({}));
    }
}

export function userLoginRequest(userData) {
    return dispatch => {
        const request_result = AJAX_PUBLIC_REQUEST("POST", "operator/login", userData);
        request_result.then(results => {
            if (results.response.code === 1000) {
                const user_data = results.response.data;
                user_data.remember = false;
                if (userData.remember === 'checked') {
                    user_data.remember = true;
                }

                SET_STORAGE(USER, JSON.stringify(user_data));
                SET_LOGIN_COOKIE(JSON.stringify(user_data));
                const cur_storage2 = GET_STORAGE(USER);
                const cur_storage = JSON.parse(cur_storage2);
                dispatch(setCurrentUser(cur_storage));
            }
        }
        );
        return request_result;
    }
}

export function mutesound(status) {
    return dispatch => {
        dispatch(
            {
                type: SET_MUTE,
                isMute: status,
            }
        )
    }
}

export function autoassign(status) {
    return dispatch => {
        dispatch(
            {
                type: SET_AUTOASSIGN,
                isAutoAssignable: status,
            }
        )
    }
}
export function setfullstory(status) {
    return dispatch => {
        dispatch(
            {
                type: SET_FULLSTORY,
                isFullStory: status,
            }
        )
    }
}
export function setLeadProcessStatus(status) {
    return dispatch => {
        dispatch(
            {
                type: SET_LEAD_PROCESS_STATUS,
                leadProcessStatus: status,
            }
        )
    }
}
export function setReloadReply(status = false) {
    return dispatch => {
        dispatch(
            {
                type: SET_RELOAD_REPLY,
                reloadReply: status,
            }
        )
    }
}
export function setLiveLeadCount(count = 0) {
    return dispatch => {
        dispatch(
            {
                type: SET_LIVE_LEAD_COUNT,
                liveLeadCount: count,
            }
        )
    }
}